import React from "react";
import { Container, Row, Col } from "reactstrap";

import appClasses from "../App.module.scss";

function cubesList(props) {
  const TagName = props.cubesSettings.componentName;

  var toReturn = (
    <div>
      {
        <Container>
          <Row>
            {props.list.map(cube => (
              <Col key={"Col" + cube.id} md="6" lg="4">
                <TagName
                  key={"Cube" + cube.id}
                  componentClass={appClasses.cube}
                  data={cube}
                />
                {/* <img src={cubeBottom} /> */}
              </Col>
            ))}
          </Row>
        </Container>
      }
    </div>
  );

  return toReturn;
}

export default cubesList;
